import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-08043799"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "overlay" }

import Spinner from './Spinner.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'SpinnerPopup',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "#app" }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(Spinner)
    ])
  ]))
}
}

})